module.exports = __webpack_public_path__ + "media/auto_history/zmiana_rejestracji-blue-d47bc7eb.svg";